import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'arm-side-nav',
  templateUrl: './arm-side-nav.component.html',
  styleUrls: ['./arm-side-nav.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class ArmSideNavComponent implements OnInit {

  @Input()
  items;

  @Input()
  title;

  @Input()
  addBorder = true;

  constructor() { }

  ngOnInit(): void {
  }

}
